import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ListsIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ListsIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 70 70">
      <g id="Group_4242">
        <g id="Group_4243">
          <g id="Group_4243-2">
            <g id="Path_2075">
              <path d="M37.87,24.41H17.5c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25h20.37c0.69,0,1.25,0.56,1.25,1.25 S38.56,24.41,37.87,24.41z" />
            </g>
            <g id="Path_2076">
              <path d="M37.87,31.62H17.5c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25h20.37c0.69,0,1.25,0.56,1.25,1.25 S38.56,31.62,37.87,31.62z" />
            </g>
            <g id="Path_2077">
              <path d="M31.66,39.85H17.5c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25h14.16c0.69,0,1.25,0.56,1.25,1.25 S32.35,39.85,31.66,39.85z" />
            </g>
          </g>
          <g id="Group_4242-2">
            <g id="Path_2078">
              <path d="M53.62,42.44H36.14c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25h17.48c0.69,0,1.25,0.56,1.25,1.25 S54.31,42.44,53.62,42.44z" />
            </g>
            <g id="Path_2079">
              <path d="M44.89,51.18c-0.69,0-1.25-0.56-1.25-1.25V32.45c0-0.69,0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25v17.48 C46.14,50.62,45.58,51.18,44.89,51.18z" />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
export default ListsIcon
